import {INavData} from "@coreui/angular";
import { IconSetService } from '@coreui/icons-angular';

import { cilSpeedometer, cilSpreadsheet } from '@coreui/icons';



export const navItems: INavData[] = [
  {
    name: 'Current Deals',
    url: '/deals',
    iconComponent: { name:  'cilBritishPound' }
  },
  {
    name: 'Dashboard',
    url: 'dashboard',
    iconComponent: { name:  'cil-speedometer' }
  },
  {
    name: 'Account(s)',
    url: '/details',
    iconComponent: { name:  'cilGroup' },
    attributes: {
      // permissions: [Permission.JobRead]
    }
  },
  // {
  //   name: 'Contracts',
  //   url: '/',
  //   iconComponent: 'fas fa-house',
  //   attributes: {
  //     // permissions: [Permission.JobRead]
  //   }
  // },
  {
    name: 'New Quote',
    url: '/quotes',
    iconComponent: { name:  'cilPlaylistAdd' },
    attributes: {
      // permissions: [Permission.JobRead]
    },
    children: [
      {
        name: ' New Bespoke Quote',
        url: '/quotes/selectbespoketemplate',
        iconComponent: { name:  'cilPlaylistAdd' },
        attributes: {}
      },
      {
        name: ' New Templated Quote',
        url: '/quotes/selecttemplate',
        iconComponent: { name:  'cilPlaylistAdd' },
        attributes: {}
      }
    ]
  },
  {
    name: 'My Quotes',
    url: '/myquotes',
    iconComponent: { name:  'cilSpreadsheet' },
    attributes: {}
  },
  {
    name: 'My Orders',
    url: '/myorders',
    iconComponent: { name:  'cilSpreadsheet' },
    attributes: {}
  },
  {
    name: 'New Remedial',
    url: '/createremedial',
    iconComponent: { name:  'cilLoopCircular' },
    attributes: {}
  },
  {
    name: 'My Remedials',
    url: '/myremedials',
    iconComponent: { name:  'cilLoopCircular' },
    attributes: {}
  },
  {
    name: 'Contact Us',
    url: '/contact',
    iconComponent: { name:  'cilPhone' },
    attributes: {}
  }

]
